import { render, staticRenderFns } from "./FireRollCallRegister.vue?vue&type=template&id=6e70d298&scoped=true"
import script from "./FireRollCallRegister.vue?vue&type=script&lang=js"
export * from "./FireRollCallRegister.vue?vue&type=script&lang=js"
import style0 from "./FireRollCallRegister.vue?vue&type=style&index=0&id=6e70d298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e70d298",
  null
  
)

export default component.exports